<template>
    <v-app-bar app class="listra" dark clipped-left>
        <!-- <v-app-bar-nav-icon @click="this.drawer = true"></v-app-bar-nav-icon> -->
        <div class="d-flex align-center">
            <!-- <v-img
            alt="Vuetify Logo"
            class="shrink mr-2"
            contain
            src="https://firebasestorage.googleapis.com/v0/b/quoon-br.appspot.com/o/quoonbr%2Flogofull.png?alt=media&token=a8582550-844b-4988-bccf-c8c620b0d84a"
            transition="scale-transition"
            width="90"
            /> -->
            <!-- <span class="title"> Quoon APP
                 </span> -->
            <v-img
            alt="Quoon Name"
            class="shrink"
            contain
            min-width="100"
            src="https://firebasestorage.googleapis.com/v0/b/quoon-br.appspot.com/o/quoonbr%2Flogofull.png?alt=media&token=0f5a44bc-2237-4b7e-be04-156ea7e3a1f3"
            width="190"
            />
        </div>

        <v-spacer></v-spacer>
        <v-badge
            :content="messages"
            :value="messages"
            color="green"
            overlap>
            <v-icon large>mdi-email</v-icon>
        </v-badge>
        <CustomerConfig />
        <v-btn icon @click="loggout()">   
            <v-icon >mdi-logout</v-icon>
        </v-btn>          
    </v-app-bar>
</template>

<script>
import {files} from "@/main"
import firebase from "firebase"
import CustomerConfig from "./CustomerConfig"

    export default {
        props: {
            source: String,
        },
        components: {
            CustomerConfig
        },
        data: () => ({
            drawer: null,
            messages: 1,
            logo: ''
        }),
        created() {
            this.$vuetify.theme.ligth = true
            this.loadCustomerInfo()
        },
        methods: {
            async loadCustomerInfo(){
                let ref = files.ref();
                let logo = ''
                await ref.child(this.$store.getters.company.data.id+'/images/logo.png').getDownloadURL().then(function(url){
                  logo = url
                })  
                this.logo = logo              
            },
            loggout(){
                firebase.auth().signOut().then(() => {
                    localStorage.clear()
                    this.$router.replace('Login')
                }).catch(function(error) {
                    console.error(error)
                });
            }
        }
    }
</script>

<style scoped>
.listra {
    background: repeating-linear-gradient(
        #296B74,
        #296B74 20px,
        #1C4C5A 20px,
        #1C4C5A 45px
    );
}
</style>